import React, { Component } from 'react'
import Menu from './includes/Menu'
import { Grid } from '../../../node_modules/@material-ui/core';
import Img01 from '../assets/images/news-20171212001-img01.png';

const lang = '';

class News20171212001 extends Component {
  constructor(props) {
    super(props);
    this.lang = (props.lang) ? props.lang : '';
  }

  componentDidMount() {
    document.title = this.getLangText({
      'tc': '新聞中心',
      'sc': '新闻中心',
      'en': 'News Center'
    });
  }

  getLangText(langJson) {
    return (this.lang) ? langJson[this.lang] : langJson['tc'];
  }

  render(){
    return(
      News20171212001JSX(this)
    );
  }
}

const News20171212001JSX = (ctx) => (
  <div className={ (ctx.lang === 'en' ? 'en' : '') }>
    <Menu lang={ ctx.lang } />
  
    <div className='main-content-container'>
      <div className='main-content-inner-wrapper newsdt'>
        <Grid container spacing={0}>
          <Grid item id='page-title'>
            <span>
              {
                ctx.getLangText({
                    'tc': '新聞',
                    'sc': '新闻',
                    'en': 'News'
                })
              }
            </span>
          </Grid>
        </Grid>
        <div style={{clear:'both'}}></div>

        <div className='newsdt-container'>
          <Grid container spacing={0} className='newsct' id='grid-section' justify='center'>
            <Grid item xs={12} sm={8} md={10} className='news-title theme-color'>
              <span>
                {
                  ctx.getLangText({
                      'tc': '鑫匯寶貴金屬榮獲2017傑出金商增值服務大獎',
                      'sc': '鑫汇宝贵金属荣获2017杰出金商增值服务大奖',
                      'en': 'Xinhuibao Precious Metals won Best Investment Value Award 2017'
                  })
                }
              </span>
            </Grid>
            <Grid item xs={12} sm={4} md={2} className='news-date'>
              <span>2017.12.12</span>
            </Grid>
          </Grid>

          <Grid item style={{width:'100%', marginBottom:'30px'}}><hr/></Grid>

          <Grid container spacing={0} className='content-container'>
            <Grid item>
              <p>
                {
                  ctx.getLangText({
                      'tc': `鑫匯寶貴金屬榮獲2017傑出金商增值服務大獎香港鑫匯寶貴金屬有限公司多年來誠信經營，用心服務。在本次由香港多家知名財經服務機構合辦的2017年最具投資價值上市公司頒獎典禮上，鑫匯寶貴金屬獲得代表評選委員一致認同，最終脫穎而出，獲得2017傑出金商增值服務大獎。`,
                      'sc': `鑫汇宝贵金属荣获2017杰出金商增值服务大奖香港鑫汇宝贵金属有限公司多年来诚信经营，用心服务。在本次由香港多家知名财经服务机构合办的2017年最具投资价值上市公司颁奖典礼上，鑫汇宝贵金属获得代表评选委员一致认同，最终脱颖而出，获得2017杰出金商增值服务大奖。`,
                      'en': `Xinhuibao Precious Metals won Best Investment Value Award 2017, Hong Kong Xinhuibao Precious Metals Co., Ltd., Integrity management for many years, dedicated service. At the awarding ceremony of the most valuable listed companies in 2017, Xinhuibao Precious Metals representatives selected members agreed, finally stand out, won the 2017 outstanding Precious Metals Merchants value added service award.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                      'tc': `近日，香港鑫匯寶貴金屬有限公司有幸參加由多家知名財經機構合辦的2017年最具投資價值上市公司頒獎典禮（Best Investment Value Award 2017以下簡稱BIVA2017）以及貴金屬行業服務大獎（Bullion Value-Added Service Award），並在此次盛典中榮獲2017傑出金商增值服務大獎。`,
                      'sc': `近日，香港鑫汇宝贵金属有限公司有幸参加由多家知名财经机构合办的2017年最具投资价值上市公司颁奖典礼（Best Investment Value Award 2017以下简称BIVA2017）以及贵金属行业服务大奖（Bullion Value-Added Service Award），并在此次盛典中荣获2017杰出金商增值服务大奖。`,
                      'en': `Recently, Hong Kong  Xinhuibao Precious Metals Co., has been lucky to participate in the 2017 award ceremony (BIVA2017) of the most investment value listed company (hereinafter referred to as Best Investment Value Award 2017) and the precious metal industry Service Award (Bullion Value-Added Service Award) jointly sponsored by a number of well-known financial institutions, and won 2017 in this event. Outstanding Gold Merchants value added service award.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                      'tc': `本次BIVA2017是由香港多家同時於香港、新加坡、北京、上海等主要亞洲金融中心皆設有業務的財經服務機構合辦，包括合規機構、財經公關公司、會計師事務所、財經數據供貨商及多家知名財經媒體，形成一個經客觀篩選、權威審核，同時得到財經媒體廣泛支持的上市公司頒獎活動。香港鑫匯寶貴金屬有限公司多年來誠信經營，用心服務，在本次評選中得到代表評選委員一致認同，最終脫穎而出，獲得2017傑出金商增值服務大獎。`,
                      'sc': `本次BIVA2017是由香港多家同时于香港、新加坡、北京、上海等主要亚洲金融中心皆设有业务的财经服务机构合办，包括合规机构、财经公关公司、会计师事务所、财经数据供货商及多家知名财经媒体，形成一个经客观筛选、权威审核，同时得到财经媒体广泛支持的上市公司颁奖活动。香港鑫汇宝贵金属有限公司多年来诚信经营，用心服务，在本次评选中得到代表评选委员一致认同，最终脱颖而出，获得2017杰出金商增值服务大奖。`,
                      'en': `This BIVA2017 is a financial service organization that has been established by several Hongkong financial centers, including Hongkong, Singapore, Beijing, Shanghai and other major Asian financial centers, including compliance agencies, financial public relations companies, accounting firms, financial data suppliers and many well-known financial media, forming an objective screening and authority. Meanwhile, the awarding activities of listed companies which were widely supported by financial media were also examined.  Hong Kong  Xinhuibao Precious Metals CO. Integrity management for many years, dedicated service, in this election, the representative of the elected members of the consensus, finally stand out, won the 2017 outstanding Precious Metals Merchants value-added service award.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                      'tc': `香港鑫匯寶貴金屬有限公司是香港金銀業貿易場106號AA類（最高類）行員，嚴格遵守行業規範的鑫匯寶貴金屬以貴金屬現貨投資等金融業務為主要經營項目。自成立之初，鑫匯寶始終以互聯網為依托，不斷提高交易策略水平和研發水平，並使用快捷、安全系數高的資金管理系統、內容豐富的學習資料以及全天候的精英團隊諮詢服務等都是鑫匯寶被稱為"投資者進行貴金屬交易首選平台"的佐證。在保證客戶資金安全的前提下，不斷提升客戶交易體驗、提高專業品質、樹立優秀服務品牌，務求為客戶帶來更完美的投資感受。`,
                      'sc': `香港鑫汇宝贵金属有限公司是香港金银业贸易场106号AA类（最高类）行员，严格遵守行业规范的鑫汇宝贵金属以贵金属现货投资等金融业务为主要经营项目。自成立之初，鑫汇宝始终以互联网为依托，不断提高交易策略水平和研发水平，并使用快捷、安全系数高的资金管理系统、内容丰富的学习资料以及全天候的精英团队谘询服务等都是鑫汇宝被称为"投资者进行贵金属交易首选平台"的佐证。在保证客户资金安全的前提下，不断提升客户交易体验、提高专业品质、树立优秀服务品牌，务求为客户带来更完美的投资感受。`,
                      'en': `Hong Kong Xinhuibao Precious Metals Co., Ltd. is a member of The Chinese Gold & Silver Exchange Society (member No. 106) and holds AA types of market trading license. precious metal investment is the main business we strict compliance with industry norms. Since its inception,  Xinhuibao Precious Metals has always relied on the Internet to continuously improve its trading strategy and R&D level. It has a convenient and high-capacity fund management system, rich learning materials and all-day elite team consulting services. We known as the "investor's preferred platform for precious metals trading". Under the premise of ensuring the safety of client funds, we will continuously improve the customer transaction experience, improve professional quality, and establish an excellent service brand, in order to bring a more perfect investment experience to customers.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                      'tc': `香港鑫匯寶貴金屬有限公司相關負責人稱，鑫匯寶蟬聯兩屆傑出金商增值服務大獎，不僅是對鑫匯寶成員多年努力結果的肯定，也是對鑫匯寶這個優良交易平台和服務水平的肯定。未來，鑫匯寶將再接再厲，不斷提升自身的技術水平及服務水平，與廣大投資者一起把握經濟形勢、共享發展盛宴。`,
                      'sc': `香港鑫汇宝贵金属有限公司相关负责人称，鑫汇宝蝉联两届杰出金商增值服务大奖，不仅是对鑫汇宝成员多年努力结果的肯定，也是对鑫汇宝这个优良交易平台和服务水平的肯定。未来，鑫汇宝将再接再厉，不断提升自身的技术水平及服务水平，与广大投资者一起把握经济形势、共享发展盛宴。`,
                      'en': `Hong Kong Xinhuibao Precious Metals Co., Ltd. the relevant person in charge said that Xinhuibao's outstanding Precious Metals value-added service award for two consecutive years is not only an affirmation of the results of many years of efforts of Xinhuibao members, but also an affirmation of Xinhuibao, an excellent trading platform and service level. In the future, Xinhuibao will make persistent efforts to continuously improve its technical level and service level, and grasp the economic situation and share development together with investors.`
                  })
                }
              </p>
            </Grid>
            <Grid container spacing={0} justify='center'>
              <Grid item>
                <img src={Img01} style={{ display:'inline-block', verticalAlign:'middle', width:'100%', height:'100%' }} />
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  </div>
)

export default News20171212001



// WEBPACK FOOTER //
// ./src/components/pages/PC20171212001.js